import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-4 col-md-6" }
const _hoisted_4 = { class: "col-lg-4 col-md-6" }
const _hoisted_5 = { class: "col-lg-4 col-md-12" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-8" }
const _hoisted_8 = { class: "col-lg-4" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-xxl-4" }
const _hoisted_11 = { class: "col-xxl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WelcomeBack = _resolveComponent("WelcomeBack")!
  const _component_TotalEmployees = _resolveComponent("TotalEmployees")!
  const _component_ResignedEmployees = _resolveComponent("ResignedEmployees")!
  const _component_NewEmployees = _resolveComponent("NewEmployees")!
  const _component_EmployeeAttendanceTrendsChart = _resolveComponent("EmployeeAttendanceTrendsChart")!
  const _component_EmployeeWorkFormatChart = _resolveComponent("EmployeeWorkFormatChart")!
  const _component_EmployeeSalaryChart = _resolveComponent("EmployeeSalaryChart")!
  const _component_EmployeeLeaveRequest = _resolveComponent("EmployeeLeaveRequest")!
  const _component_EmployeeList = _resolveComponent("EmployeeList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WelcomeBack),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TotalEmployees)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ResignedEmployees)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_NewEmployees)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_EmployeeAttendanceTrendsChart)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_EmployeeWorkFormatChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_EmployeeSalaryChart)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_EmployeeLeaveRequest)
      ])
    ]),
    _createVNode(_component_EmployeeList)
  ]))
}